// import { get } from "lodash";

export default {
  selectPlatformModules: (state) => state.platformModules.modules,
  selectModuleDetail: (state) => state.platformModules.moduleDetail,
};
